import React, { useCallback, useEffect, useState } from 'react';
import { Separator } from '../../common/form';
import Authenticator from '../../protocol/Authenticator';
import ThumbnailUtil from '../../util/ThumbnailUtil';
import './setting.css';
import SettingsForm from './SettingsForm';
import EditProfileImage from './EditProfileImage';
import { InputSearch } from '../AssetsListHeader';
import _ from 'lodash';
import ViewUtil from '../../ViewUtil';
import getSettingFormData from './settingForm';
import SaveSettings from '../../queries/settings/SaveSettings';
import HashMap from '../../protocol/HashMap';
import t from '../../i18n/I18n';
import AuthenticationController from '../../controllers/AuthenticationController';
import MediaStore from './MediaStore';
import { HeightLeftWithoutHeaderInCalc } from '../../util/ScreenUtil';
const Setting = ({ currentSetting }) => {
  const [searchString, setSearchString] = useState('');
  const [formData, setFormData] = useState([]);
  const [isSearchActive, onSearchActive] = useState(false);
  const debounceSearch = useCallback(
    _.debounce((value) => setSearchString(value), 500),
    []
  );

  useEffect(() => {
    setFormData(getSettingFormData(currentSetting, searchString));
  }, [searchString]);

  const saveDefaultSetting = (data) => {
    const settingMap: HashMap = new HashMap();
    const globalSettingMap: HashMap = new HashMap();
    data.forEach((setting) => {
      if (setting.global) {
        if ('dropDown' == setting.type) {
          globalSettingMap.put(setting.key, setting.options[setting.value].label);
        } else {
          globalSettingMap.put(setting.key, setting.value);
        }
      } else {
        if ('dropDown' == setting.type) {
          settingMap.put(setting.key, setting.options[setting.value].label);
        } else {
          settingMap.put(setting.key, setting.value);
        }
      }
    });
    SaveSettings.saveMultipleAsync({
      settingMap,
      globalSettingMap
    }).then((resp) => {
      if (resp) AuthenticationController.updateSessionSettings();
    });
  };

  const setDefaultValue = () => {
    let data = getSettingFormData(currentSetting, searchString, true);
    setFormData(data);
    saveDefaultSetting(...data);
  };

  return (
    <div name="Setting" style={{ height: HeightLeftWithoutHeaderInCalc }}>
      <div className="setting-main">
        <div className="backTosStting">
          <div style={{ width: 'max-content' }} onClick={() => ViewUtil.switchToTab('SETTINGS')}>
            <img src="images/arrow_left_gray.svg" draggable="true" width="15px" />
            <span style={{ color: 'var(--primary-font-color)' }}>{t('BACK TO SETTINGS')}</span>
          </div>
        </div>
        <div className="settingHeader">
          <div className="setting_title">{currentSetting}</div>
          {'Profile' != currentSetting && 'Evolphin Media Store Drives' != currentSetting && (
            <div className="settingAction">
              <div onClick={setDefaultValue} style={{ margin: '10px 10px 10px 0px' }}>
                <i className="fa fa-repeat" style={{ marginRight: '5px' }} aria-hidden="true"></i>
                {t('RESET_TO_DEFAULT')}
              </div>
              <InputSearch onInput={debounceSearch} settingSearch onSearchActive={onSearchActive} isSearchActive={isSearchActive} />
            </div>
          )}
        </div>
        {'Profile' == currentSetting && <ProfileHeader />}
        {'Evolphin Media Store Drives' === currentSetting && <MediaStore />}
        <Separator />
        {formData.length ? <SettingsForm formData={formData} /> : null}
      </div>
    </div>
  );
};

const ProfileHeader = () => {
  const [fullName, SetFullName] = useState('');
  const [email, setEmail] = useState('');
  useEffect(() => {
    ThumbnailUtil.loadUserFullName(Authenticator.AUTH_DATA.username).then((fullName) => {
      SetFullName(fullName);
    });

    ThumbnailUtil.fetchEmailAddress(Authenticator.AUTH_DATA.username).then((email) => {
      setEmail(email);
    });
  }, []);

  return (
    <div className="profileHeader">
      <EditProfileImage />
      <div className="userDetails">
        <span className="fullName">{fullName}</span>
        <span className="email">{email}</span>
      </div>
    </div>
  );
};

export default Setting;
